<template>
    <div class="jd-expert--income">
        <!--<k-row class="table-head  ta-center">
            <k-col span="10">日期</k-col>
            <k-col span="7">状态</k-col>
            <k-col span="7">金额</k-col>
        </k-row>-->
        <k-cell-group v-if="getTakeList">
            <k-cell v-for="(item,index) in getTakeList" :key="index" :title="takeTitle(item.realTake)" :value="statusText(item.status)">
                <template slot="desc">
                    <div>
                        <div>
                            {{item.remark}}
                            <span v-if="item.type === 2"> {{item.cause.realName ||''}} {{item.cause.mobile || ''}}</span>
                            <span v-if="item.type === 3"> {{item.cause.realName ||''}} {{item.cause.aliAccount || ''}}</span>
                        </div>
                        <label>{{item.time*1000|formatDate}}</label>
                    </div>
                </template>
            </k-cell>
            <k-hr />
        </k-cell-group>
        <div v-if="finished || !getTakeList.length" class="k-nodata">暂无更多数据！</div>
        <!--<template v-if="getTakeList">
            <div v-if="getTakeList.length">
                <k-row v-for="(item,index) in getTakeList" :key="index" class="table-body cl-desc ta-center">
                    <k-col span="10">{{item.time*1000|formatDate}}</k-col>
                    <k-col span="7">{{statusText(item.status)}}</k-col>
                    <k-col span="7">¥{{item.realTake|fen2yuan(2)}}</k-col>
                </k-row>
            </div>
            <div v-if="finished || !getTakeList.length" class="k-nodata">暂无更多数据！</div>
        </template>-->
        <k-pagination
            v-if="totalPage>1"
            v-model="page"
            :page-count="totalPage"
            mode="simple"
        />
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {fen2yuan} from "../../utils/filters";

    export default {
        name: "withdraw-list",
        data() {
            return {
                list        : [],
                pageNum     : 50,
                statusList  : ["待处理", "提现成功", "驳回"],
                finished    : false,
                page        : 1,
                totalPage   : 1,
            }
        },
        computed : {
            ...mapGetters("jianding", ["getTakeInfo", "getTakeList"]),


        },
        methods:{
            ...mapActions("jianding", [ "loadTake"]),
            async load(){
                let { page, pageNum }   = this;
                let query               = {page,pageNum};

                this.$toast.loading({message:"正在加载",duration : 0});

                const R                 = await this.loadTake(query);

                let {list}              = R;
                this.totalPage          = (R.total / this.pageNum) || 1;

                if(list && list.length){
                    this.page           = R.page;
                    if(list.length < this.pageNum){
                        this.finished   = true
                    }
                }
                this.$toast.clear();
            },
            statusText(status){
                return this.statusList[status]
            },
            takeTitle(num){
                return `¥${fen2yuan(num,2)}`
            }
        },
        created() {
            this.load()
        }
    }
</script>

<style scoped>

</style>